import { firebaseDb as db } from '../firebase'

import { asyncRequest, asyncSuccess, asyncFail, cleanMessages } from '../actions'

export const fetchProjectUsers = projectId => {
  return dispatch => {
    dispatch(asyncRequest('fetchProjectUsers'))

    const projectUsersRef = db.collection('projects').doc(projectId).collection('projectUsers')

    projectUsersRef
      .get()
      .then(usersSnap => {
        const users = {}
        usersSnap.forEach(doc => {
          users[doc.id] = doc.data()
          // users[doc.id].id = doc.id
        })
        dispatch(asyncSuccess('fetchProjectUsers', { users }, null))
      })
      .catch(error => {
        console.log(error)
        dispatch(asyncFail('fetchProjectUsers', error.code))
        dispatch(cleanMessages())
      })
  }
}

export const updateProjectUsersCollection = (projectId, newUsers, companyUsers) => {
  const newUsersIds = newUsers.userIds

  return dispatch => {
    const projectUsersRef = db.collection('projects').doc(projectId).collection('projectUsers')

    projectUsersRef
      .get()
      .then(projectUsersSnap => {
        // create batch
        const batch = db.batch()

        projectUsersSnap.forEach(projectUserDoc => {
          // add each delete() function to the batch
          batch.delete(projectUserDoc.ref)
        })

        const updatedUsers = {}
        newUsersIds.forEach(newUserId => {
          const newUserObject = {
            name_sync: companyUsers[newUserId].name_sync,
            notifications: true
          }
          // add each set() function to the batch
          batch.set(projectUsersRef.doc(newUserId), newUserObject)
          updatedUsers[newUserId] = newUserObject
        })

        // Commit the batch
        batch.commit()

        dispatch(asyncSuccess('updateProjectUsersCollection', { updatedUsers }, null))
      })
      .catch(error => {
        console.log(error)
        dispatch(asyncFail('updateProjectUsersCollection', error.code))
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/projectUsers.js